<template>
    <!-- 自定义弹窗 -->
    <van-popup :value="value"
               @input="changeInput"
               closeable
               round
               position="bottom">
        <div class="tit">
            <span>{{title}}</span>
        </div>
        <div class="body">
            <slot></slot>
        </div>
    </van-popup>
</template>

<script>
  import { Popup } from 'vant';
  import Vue from 'vue';

  Vue.use(Popup);

  export default {
    name: "MyPopup",
    props: {
      // 是否显示
      value: {
        type: Boolean,
        default: false
      },
      // 标题
      title: String
    },
    data() {
      return {}
    },
    created() {

    },
    methods: {
      changeInput(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="less" scoped>
    .tit {
        height: 108px;
        line-height: 108px;
        padding-left: 30px;
        overflow: hidden;

        span {
            font-size: 32px;
        }
    }

    /deep/ .van-popup__close-icon {
        top: 36px;
    }

    .van-popup--bottom.van-popup--round {
        border-radius: 30px 30px 0 0;
    }

    .body {
        min-height: 500px;
    }
</style>
